
import { ILandUserInvite } from "@libs/interfaces/layouts";
import { showToast } from "@libs/useful";
import { __ } from "@libs/utilities";
import { ILand, USER_EVENT_REQUEST_STATUS } from "@/modules/pe-fest-module/data/interfaces";
import { IUser } from "@/settings/zustand";
import { Button, Intent } from "@blueprintjs/core";
import { useParams } from "react-router";
import actions from "../data/actions";
import { GET_FEED_ACTION, REMOVE_REQUEST_INVITE_ACTION, UPDATE_USER_LAND_REQUEST_ACTION } from "../data/actionTypes";
import { useDataStore } from "../data/store";

/* Protopia Ecosystem component */
export interface IUserRequestInviteWidgetProps {
    parent: any
}
const UserRequestInviteWidget = (props: IUserRequestInviteWidgetProps): JSX.Element => {
    const user: IUser = props.parent.user 
    const {landId} = useParams()
    const lands:ILand[] = useDataStore( (state: any) => state.Land || [] )
    const land: ILand = lands.find(land => land.id === landId ) || {} as ILand 

    const onStatus = ( key: keyof typeof USER_EVENT_REQUEST_STATUS) => { 
        let item : ILandUserInvite = {
            ...props.parent,
            status: key,
            user_id: props.parent.user_id || props.parent.user?.id,
            land_id: props.parent.land_id || props.parent.land?.id,
        }
        delete item.land
        delete item.user
        delete item.__typename 
        actions(
            UPDATE_USER_LAND_REQUEST_ACTION, 
            { 
                item, 
                land_id:  props.parent.land_id || props.parent.land?.id,
                id: props.parent.user_id || props.parent.user?.id,
            }
        )
            .then(() => {
                actions(GET_FEED_ACTION, {
                    data_type: "LandUserInvite",
                    land_id: props.parent.land_id || props.parent.land?.id,
                })
                .then(() => {
                    showToast({
                        message: __("Feed updated")
                    })
                })
                showToast({
                    message: __("Successfully remove")
                })
            })
    }
    return <div className='pe-user-request-invite-widget-container'>
        {
            Object.keys( USER_EVENT_REQUEST_STATUS )
            .filter( key => key !== USER_EVENT_REQUEST_STATUS.NONE )
            .map(( key ) => {
                return <Button 
                    key={key} 
                    variant={ props.parent.status !== key ? "minimal": "solid" } 
                    intent={  props.parent.status !== key ? Intent.NONE : Intent.SUCCESS} 
                    onClick={(evt ) => onStatus(key as  keyof typeof USER_EVENT_REQUEST_STATUS)}
                >
                    { __( "USER_EVENT_REQUEST_STATUS." + key ) } 
                </Button>
            }) 
        } 
    </div>
} 
export default UserRequestInviteWidget